import { render, staticRenderFns } from "./ChangePass.vue?vue&type=template&id=7d80dfb4&"
import script from "./ChangePass.vue?vue&type=script&lang=ts&"
export * from "./ChangePass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports